/**
 * D9: Adaptive Engine Config (V11_CONFIG runtime overrides)
 * Source: src/mastery/selection/v11ConfigStore.ts
 *
 * Stores runtime overrides for V11_CONFIG so that admin-configured
 * adaptive engine parameters survive page reloads.
 */

import { isBackendEnabled, removeKey } from '../helpers';

// Per domein — dit domein heeft nog geen backend. Zie helpers.ts.
const USE_BACKEND = isBackendEnabled('adaptiveConfig');
import { safeStorageWrite } from '../../utils/storageQuota';
const ADAPTIVE_CONFIG_KEY = 'meester_djay_adaptive_config_v1';
export async function getAdaptiveConfig(): Promise<Record<string, unknown> | null> {
  if (USE_BACKEND) {
    throw new Error('Backend not implemented');
  }
  try {
    const raw = localStorage.getItem(ADAPTIVE_CONFIG_KEY);
    if (!raw) return null;
    return JSON.parse(raw);
  } catch {
    return null;
  }
}
export async function saveAdaptiveConfig(config: Record<string, unknown>): Promise<boolean> {
  if (USE_BACKEND) {
    throw new Error('Backend not implemented');
  }
  return safeStorageWrite(ADAPTIVE_CONFIG_KEY, JSON.stringify(config));
}
export async function resetAdaptiveConfig(): Promise<void> {
  if (USE_BACKEND) {
    throw new Error('Backend not implemented');
  }
  removeKey(ADAPTIVE_CONFIG_KEY);
}